exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insufficient-balance .deposit{margin-bottom:0}.insufficient-balance .deposit__desc{color:var(--red)}.insufficient-balance .global-card__type--block{border:initial;background-color:initial;border-radius:0;padding:0}", ""]);

// exports
